// VerificationBanner.js - FINAL VERSION
// Button-style banner like "Reset link sent"
import React, { useState } from 'react';
import './VerificationComponents.css';

function VerificationBanner({ accountTier }) {
  const [loading, setLoading] = useState(false);

  // Hide completely if verified
  if (accountTier === 'verified') {
    return null;
  }

  const handleClick = async () => {
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      
      const response = await fetch('/api/kyc/create-verification-session', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          returnUrl: `${window.location.origin}/verification-complete`
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to create verification session');
      }

      const data = await response.json();

      // Redirect to Stripe Identity verification
      window.location.href = data.url;

    } catch (err) {
      console.error('Error starting verification:', err);
      setLoading(false);
    }
  };

  // Show verification prompt if unverified
  // Button style - matches "Reset link sent" design
  return (
    <div 
      className="verification-banner-button"
      onClick={handleClick}
      style={{ cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
    >
      <span>{loading ? 'Starting verification...' : 'Identity verification required'}</span>
    </div>
  );
}

export default VerificationBanner;
